import React from 'react';
import { Home, Search, HelpCircle, Phone } from 'lucide-react';
export function MobileStickyBar() {
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-brand-border shadow-[0_-10px_20px_rgba(9,46,37,0.05)] z-50 pb-safe" data-id="element-430">
      <div className="flex justify-around items-center h-16" data-id="element-431">
        <a href="/" className="flex flex-col items-center justify-center w-full h-full text-brand-charcoal hover:text-brand-green transition-colors active:bg-brand-cream" data-id="element-432">
          <Home size={22} className="mb-1" data-id="element-433" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-434">
            Shop
          </span>
        </a>
        <button className="flex flex-col items-center justify-center w-full h-full text-brand-charcoal hover:text-brand-green transition-colors border-l border-brand-border/50 active:bg-brand-cream" data-id="element-435">
          <Search size={22} className="mb-1" data-id="element-436" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-437">
            Search
          </span>
        </button>
        <a href="/help-choosing.html" className="flex flex-col items-center justify-center w-full h-full text-brand-charcoal hover:text-brand-green transition-colors border-l border-brand-border/50 active:bg-brand-cream" data-id="element-438">
          <HelpCircle size={22} className="mb-1" data-id="element-439" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-440">
            Help
          </span>
        </a>
        <a href="tel:301-620-7585" className="flex flex-col items-center justify-center w-full h-full text-brand-red hover:text-brand-red/80 transition-colors border-l border-brand-border/50 active:bg-red-50" data-id="element-441">
          <Phone size={22} className="mb-1" data-id="element-442" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-443">
            Call
          </span>
        </a>
      </div>
    </div>;
}